// extracted by mini-css-extract-plugin
export default {"record_option_switch":"RecordOptionSwitch_record_option_switch__BhHiP","active":"RecordOptionSwitch_active__2zf0r"};